import { ReactNode } from "react";
import { Icon, type IconProps } from "~/components/icon/icon";
import { cn } from "~/utils";

interface CautionPillProps {
  children: ReactNode;
  icon?: IconProps["name"];
  className?: string;
}

/**
 * Small inline pill for caution/partial-data callouts (e.g. anchoring a
 * truncated chart to its first available data point). Uses the semantic
 * `caution` color tokens rather than raw `amber-*` classes.
 */
export const CautionPill = ({
  children,
  icon = "info",
  className,
}: CautionPillProps) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 rounded-full border border-caution-200 bg-caution-50 px-2 py-0.5 text-xs font-medium text-caution-800",
      className,
    )}
  >
    <Icon name={icon} size="small" iconClassName="text-caution-600" />
    {children}
  </span>
);
